/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import React from 'react';
import { IntlProvider } from 'react-intl';
import { observer } from 'mobx-react';
import RouterConfig from '../../navigation/RouterConfig';
import { AppViewModel } from './AppViewModel';
import { SnackbarProvider } from 'notistack';
import SnackbarView from '../../components/Snackbar/SnackbarView';
import CustomSnackbar from '../../components/Snackbar/CustomSnackbar';
import { useViewModel } from '../../hooks/useViewModel';
import { autorun } from 'mobx';
import { Lang } from '../../assets/lang/lang';

const AppView = observer((): React.ReactNode => {
	const viewModel: AppViewModel = useViewModel(AppViewModel);
	const locale: Lang = viewModel.getLanguage();

	autorun(() => {
		viewModel.subscribeToUserChanges().forEach(() => {
			viewModel.updateLocStorage();
		});
	});

	return (
		<IntlProvider locale={locale} messages={viewModel.getTranslation()}>
			<SnackbarProvider
				maxSnack={3}
				Components={{
					default: CustomSnackbar,
					success: CustomSnackbar,
					error: CustomSnackbar,
					warning: CustomSnackbar,
					info: CustomSnackbar,
				}}>
				<RouterConfig />
				<SnackbarView />
			</SnackbarProvider>
		</IntlProvider>
	);
});

export default AppView;
